/* MRCH Mixpanel tracker (A14). No token/PII/raw queries. */
(function(w){
'use strict';
var LS=w.localStorage||null,SS=w.sessionStorage||null;
var boot=(w.MRCH_ANALYTICS&&typeof w.MRCH_ANALYTICS==='object')?w.MRCH_ANALYTICS:{};
var H=!!w.__MRCH_ANALYTICS_HARNESS__,noop=function(){};
w.MRCH_ANALYTICS=boot;boot.track=noop;
if(!boot.token||!String(boot.token).trim())return;

var K={a:'mrch_mp_anonymous_id',s:'mrch_mp_session_id',l:'mrch_mp_last_activity',f:'mrch_mp_first_seen',fs:'mrch_mp_ft_source',fm:'mrch_mp_ft_medium',fc:'mrch_mp_ft_campaign',ft:'mrch_mp_ft_at',us:'mrch_mp_utm_source',um:'mrch_mp_utm_medium',uc:'mrch_mp_utm_campaign',un:'mrch_mp_utm_content',ut:'mrch_mp_utm_term',e:'mrch_mp_entry_source_type',c:'mrch_mp_checkout_started',q:'mrch_mp_search_dedup',sp:'mrch_mp_spotlight_seen'};
var SM=30*60*1000,FT=180*24*60*60*1000;
var PM={cpc:1,ppc:1,paid:1,paid_social:1,paidsocial:1,cpm:1,cpa:1,display:1};
var PS={google:1,bing:1,facebook:1,fb:1,instagram:1,meta:1};
var SS0={instagram:1,tiktok:1,twitter:1,x:1,pinterest:1,facebook:1,youtube:1};
var SM0={social:1,organic_social:1},CM={creator_share:1,creator:1},EM={email:1,owned:1};
var XH={'sellmerch.ai':1,'www.sellmerch.ai':1,'backstageai.com':1,'www.backstageai.com':1,'mrch.live':1,'www.mrch.live':1};
var CH={'www.sellmerch.ai':1,'sellmerch.ai':1,'apps.apple.com':1,'play.google.com':1,'www.backstageai.com':1,'backstageai.com':1};
var AE={development:1,preview:1,production:1};
var BAD={email:1,phone:1,shipping_address:1,billing_address:1,raw_prompt:1,raw_generated_copy:1,unredacted_error:1,customer_email:1,q:1,query:1};
var st={on:0,cs:'no_interaction',anon:null,sid:null,nw:0,pv:0,ch:null,cts:0,atc:{},ba:{}};

function g(s,k){try{return s?s.getItem(k):null;}catch(e){return null;}}
function p(s,k,v){try{if(s)s.setItem(k,v);}catch(e){}}
function d(s,k){try{if(s)s.removeItem(k);}catch(e){}}
function uuid(){
  if(w.crypto&&w.crypto.randomUUID)return w.crypto.randomUUID();
  var a=new Uint8Array(16),i,h=[];
  if(w.crypto&&w.crypto.getRandomValues)w.crypto.getRandomValues(a);else for(i=0;i<16;i++)a[i]=Math.floor(Math.random()*256);
  a[6]=(a[6]&15)|64;a[8]=(a[8]&63)|128;
  for(i=0;i<16;i++)h.push((a[i]+256).toString(16).slice(1));
  return h.slice(0,4).join('')+'-'+h.slice(4,6).join('')+'-'+h.slice(6,8).join('')+'-'+h.slice(8,10).join('')+'-'+h.slice(10).join('');
}
function env(){var e=String(boot.environment||'preview').toLowerCase();return AE[e]?e:'preview';}
function loc(){return w.location||{href:'',pathname:'/',search:'',hostname:''};}
function hostOf(u){
  if(!u)return '';
  try{if(u.indexOf('//')===0)u='https:'+u;return new URL(u,loc().href).hostname.toLowerCase();}catch(e){return String(u).toLowerCase();}
}
function pan(s){return /\b\d{13,19}\b/.test(String(s).replace(/[-\s]/g,''));}
function su(v){if(v==null)return '';var s=String(v).trim();return(!s||s.length>200||s.indexOf('@')>=0||pan(s))?'':s;}
function parseUtms(search){
  var o={utm_source:'',utm_medium:'',utm_campaign:'',utm_content:'',utm_term:'',has_gclid:false,mrch_share:false,store_q:''};
  try{var p=new URLSearchParams(search||loc().search||'');
    o.utm_source=su(p.get('utm_source'));o.utm_medium=su(p.get('utm_medium'));o.utm_campaign=su(p.get('utm_campaign'));
    o.utm_content=su(p.get('utm_content'));o.utm_term=su(p.get('utm_term'));
    o.has_gclid=!!(p.get('gclid')||p.get('fbclid'));o.mrch_share=p.get('mrch_share')==='1';o.store_q=su(p.get('store_id')||'');
  }catch(e){}
  return o;
}
function hasUtm(u){return !!(u.utm_source||u.utm_medium||u.utm_campaign||u.utm_content||u.utm_term);}
function pre(s,a){for(var i=0;i<a.length;i++)if(s.indexOf(a[i])===0)return 1;return 0;}
function shopHop(h){return !!h&&(h==='shop.app'||/(^|\.)shopify\.com$/.test(h));}
function thisShop(h){if(!h)return 0;var x=(loc().hostname||'').toLowerCase();return h===x||h==='www.mrch.shop'||h==='mrch.shop';}
function refHost(){try{return hostOf(w.document&&w.document.referrer);}catch(e){return '';}}
function classify(utm,rh,ex){
  ex=ex||{};var m=(utm.utm_medium||'').toLowerCase(),s=(utm.utm_source||'').toLowerCase(),c=(utm.utm_campaign||'').toLowerCase(),h=(rh||'').toLowerCase();
  if(shopHop(h))return null;
  if(PM[m]||(PS[s]&&PM[m]))return 'paid';
  if(CM[m]||pre(c,['creator_'])||(ex.mrchShare&&ex.hasStore))return 'creator_share';
  if(EM[m]||pre(c,['spotlight_','editorial_','collection_','mrch_email_'])||ex.spotlightId)return 'mrch_spotlight';
  if(SM0[m]||SS0[s])return 'social';
  if(XH[h])return 'cross_domain';
  if(h&&/(^|\.)(google|bing|duckduckgo|yahoo|baidu|yandex)\./.test(h))return 'organic_search';
  if(h&&/(instagram\.com|tiktok\.com|(^|\.)t\.co$|x\.com|twitter\.com|pinterest\.com|facebook\.com|l\.facebook\.com|youtube\.com|youtu\.be|reddit\.com)/.test(h))return 'social';
  if(h&&!thisShop(h)&&!shopHop(h))return 'referral';
  if(!h&&!utm.utm_source&&!utm.utm_medium)return 'direct';
  return 'unknown';
}
function touch(){
  var last=parseInt(g(SS,K.l)||'0',10),sid=g(SS,K.s);
  if(!sid||!last||Date.now()-last>SM){sid=uuid();p(SS,K.s,sid);}
  p(SS,K.l,String(Date.now()));st.sid=sid;return sid;
}
function firstTouch(utm,rh,cl){
  var at=parseInt(g(LS,K.ft)||'0',10);
  if(at&&Date.now()-at>FT){d(LS,K.fs);d(LS,K.fm);d(LS,K.fc);d(LS,K.ft);}
  var s=g(LS,K.fs)||'',m=g(LS,K.fm)||'',c=g(LS,K.fc)||'';
  if(s&&m&&c)return;
  var strong=hasUtm(utm)||(cl&&cl!=='direct'&&cl!=='unknown');
  if(!strong)return;
  if(!s)p(LS,K.fs,utm.utm_source||rh||'direct');
  if(!m)p(LS,K.fm,utm.utm_medium||'');
  if(!c)p(LS,K.fc,utm.utm_campaign||'');
  if(!g(LS,K.ft))p(LS,K.ft,String(Date.now()));
}
function sessAttr(utm,rh,ex){
  var cl=classify(utm,rh,ex),exs=g(SS,K.e)||'';
  if(cl==null)cl=exs||'unknown';
  if(!exs||exs==='direct'||exs==='unknown')p(SS,K.e,cl||'unknown');
  if(hasUtm(utm)){p(SS,K.us,utm.utm_source);p(SS,K.um,utm.utm_medium);p(SS,K.uc,utm.utm_campaign);p(SS,K.un,utm.utm_content);p(SS,K.ut,utm.utm_term);}
  firstTouch(utm,rh,cl);
}
function strip(url){
  if(!url)return '';
  try{var u=new URL(url,loc().href);['q','email','checkout','token','gclid','fbclid'].forEach(function(k){u.searchParams.delete(k);});u.hash='';return u.toString();}
  catch(e){return String(url).split('?')[0];}
}
function hex(buf){var v=new Uint8Array(buf),o='',i;for(i=0;i<v.length;i++)o+=(v[i]+256).toString(16).slice(1);return o;}
function sha(t){if(!w.crypto||!w.crypto.subtle||!t)return Promise.resolve(null);return w.crypto.subtle.digest('SHA-256',new TextEncoder().encode(t)).then(hex).catch(function(){return null;});}
function storeId(pr,vendor){
  if(pr&&pr.store_id)return String(pr.store_id);
  if(pr&&pr.store_id_metafield)return String(pr.store_id_metafield);
  if(pr&&pr.vendor_blocked)return 'unmapped';
  var h=(pr&&pr.vendor_handle)||'';
  if(!h&&vendor)h=String(vendor).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  return h?('vendor_handle:'+h):'unmapped';
}
function surface(){
  if(boot.collection&&boot.collection.merchandising_surface)return boot.collection.merchandising_surface;
  var t=boot.page_type;if(t==='search')return 'search';if(t==='home')return 'home_featured';
  return (boot.collection&&boot.collection.handle)||t||'unknown';
}
function common(){
  var o={
    environment:env(),event_schema_version:boot.event_schema_version||'1.0',app_id:'mrch_shop',
    session_id:st.sid||g(SS,K.s),anonymous_id:st.anon,page_url:strip(boot.canonical_url||loc().href),
    page_path:loc().pathname||boot.page_path||'/',page_type:boot.page_type||'other',referrer_domain:refHost(),
    first_touch_source:g(LS,K.fs)||'',first_touch_medium:g(LS,K.fm)||'',first_touch_campaign:g(LS,K.fc)||'',
    entry_source_type:g(SS,K.e)||'unknown',is_new_visitor:!!st.nw,consent_state:st.cs,currency:boot.currency||'USD'
  };
  if(boot.page_id)o.page_id=String(boot.page_id);
  if(boot.customer_id)o.authenticated_user_id=String(boot.customer_id);
  ['us:utm_source','um:utm_medium','uc:utm_campaign','un:utm_content','ut:utm_term'].forEach(function(pair){
    var a=pair.split(':'),v=g(SS,K[a[0]]);if(v)o[a[1]]=v;
  });
  if(boot.product){
    if(boot.product.product_id)o.product_id=String(boot.product.product_id);
    if(boot.product.store_id)o.store_id=String(boot.product.store_id);
    if(boot.product.creator_id_metafield)o.creator_id=String(boot.product.creator_id_metafield);
    o.enrichment_status=boot.product.enrichment_status;o.content_version=boot.product.content_version;
    o.listing_enrichment_cohort=boot.product.listing_enrichment_cohort;
    o.experiment_id='listing_enrichment_v1';o.experiment_variant=boot.product.listing_enrichment_cohort||'unassigned';
  }
  if(boot.collection&&boot.collection.id)o.collection_id=String(boot.collection.id);
  if(st.ch)o.cart_id_hash=st.ch;
  return o;
}
function clean(pr){var o={},k;for(k in pr)if(pr[k]!==undefined&&!BAD[k])o[k]=pr[k];return o;}
function mix(){return w.mixpanel;}
function track(n,x){if(!st.on)return;touch();var mixp=mix();if(mixp&&mixp.track)mixp.track(n,clean(Object.assign({},common(),x||{})));}
boot.track=function(n,x){track(n,x);};

function qClass(q){
  if(!q)return '';if(/@/.test(q)||/\+?\d[\d\s.-]{7,}\d/.test(q))return 'redacted';
  var t=q.trim().split(/\s+/);if(t.length===1)return /^(tee|hoodie|hat|mug|sticker|sweatshirt|shirt)$/i.test(t[0])?'looks_like_type':'one_token';
  return 'multi_token';
}
function fireSearch(rc,len){
  var tok=String(st.sid)+':'+String(len||0),stamp=g(SS,K.q);
  if(stamp&&Date.now()-parseInt(stamp.split('|')[0],10)<2000&&stamp.split('|')[1]===tok)return;
  p(SS,K.q,Date.now()+'|'+tok);
  var x={result_count:rc==null?-1:Number(rc)};if(len!=null)x.query_len=Number(len);track('Search Submitted',x);
}
function dirView(){
  if(boot.page_type==='not_found'||boot.page_type!=='collections_index')return;
  var root=w.document.querySelector('[data-merchandising-surface="creator_directory"]');if(!root)return;
  track('Creator Directory Viewed',{result_count:root.querySelectorAll('li a, a.reversed-link').length,merchandising_surface:'creator'});
}
function pageView(){
  if(st.pv||boot.page_type==='password'||(loc().pathname||'').indexOf('/challenge')===0)return;
  st.pv=1;
  var u=parseUtms();
  sessAttr(u,refHost(),{mrchShare:u.mrch_share,hasStore:!!(u.store_q||(boot.product&&boot.product.store_id)),spotlightId:!!w.document.querySelector('[data-mrch-spotlight-id],[data-spotlight-id]')});
  touch();track('Page Viewed',{});
  if(boot.page_type==='collection'&&boot.collection&&boot.collection.id){
    track('Collection Viewed',{collection_id:String(boot.collection.id),collection_handle:boot.collection.handle,product_count:boot.collection.products_count,merchandising_surface:boot.collection.merchandising_surface||surface()});
  }
  if(boot.page_type==='product'&&boot.product&&boot.product.product_id){
    track('Product Viewed',{product_id:String(boot.product.product_id),store_id:storeId(boot.product)||'unmapped',availability:boot.product.available?'in_stock':'unavailable',currency:boot.currency||'USD',enrichment_status:boot.product.enrichment_status||'unenriched',variant_id:boot.product.variant_id?String(boot.product.variant_id):undefined,price:boot.product.price,product_type:boot.product.product_type,content_version:boot.product.content_version,listing_enrichment_cohort:boot.product.listing_enrichment_cohort});
  }
  if(boot.page_type==='search'&&boot.search&&boot.search.has_terms)fireSearch(boot.search.results_count,boot.search.terms_len);
  dirView();
}
function spots(){
  var nodes=w.document.querySelectorAll('[data-mrch-spotlight-id],[data-spotlight-id]');
  if(!nodes.length||typeof w.IntersectionObserver!=='function')return;
  var seen={};try{seen=JSON.parse(g(SS,K.sp)||'{}')||{};}catch(e){seen={};}
  var tm={};
  var io=new w.IntersectionObserver(function(ents){
    ents.forEach(function(en){
      var id=en.target.getAttribute('data-mrch-spotlight-id')||en.target.getAttribute('data-spotlight-id');
      if(!id||seen[id])return;
      if(en.isIntersecting&&en.intersectionRatio>=0.5){
        tm[id]=w.setTimeout(function(){if(seen[id])return;seen[id]=1;p(SS,K.sp,JSON.stringify(seen));track('Spotlight Viewed',{spotlight_id:id,merchandising_surface:'spotlight'});},500);
      }else if(tm[id])w.clearTimeout(tm[id]);
    });
  },{threshold:[0.5]});
  for(var i=0;i<nodes.length;i++)io.observe(nodes[i]);
}
function handleOf(href){var m=String(href||'').match(/\/products\/([^\/?#]+)/);return m?decodeURIComponent(m[1]):'';}
function cardObj(a){
  var near=function(attr){return a.getAttribute(attr)||(a.closest('['+attr+']')&&a.closest('['+attr+']').getAttribute(attr));};
  var type=near('data-mrch-object-type')||'product',id=near('data-mrch-object-id'),place=near('data-mrch-placement')||surface(),pos=parseInt(near('data-mrch-position')||'0',10);
  if(!id){var h=handleOf(a.getAttribute('href')),map=boot.productHandles||{};if(h&&map[h]!=null)id=String(map[h]);}
  if(!pos){var card=a.closest('.product-card'),list=card&&card.parentElement?card.parentElement.children:[];for(var i=0;i<list.length;i++)if(list[i]===card){pos=i+1;break;}}
  return {object_type:type,object_id:id?String(id):'',placement:place||'unknown',position:pos||0};
}
function okClick(ev){return H||!!(ev&&ev.isTrusted);}
function shareCh(href){
  var h=hostOf(href);if(String(href).indexOf('mailto:')===0)return 'email';
  if(h.indexOf('facebook')>=0)return 'facebook';if(h.indexOf('twitter')>=0||h==='x.com')return 'twitter';
  if(h.indexOf('pinterest')>=0)return 'pinterest';if(h.indexOf('telegram')>=0)return 'telegram';if(h.indexOf('whatsapp')>=0)return 'whatsapp';
  return 'unknown';
}
function shareObj(){
  if(boot.product&&boot.product.product_id)return {object_type:'product',object_id:String(boot.product.product_id)};
  if(boot.page_type==='article'&&boot.page_id)return {object_type:'article',object_id:String(boot.page_id)};
  return {object_type:'page',object_id:boot.page_id?String(boot.page_id):(loc().pathname||'/')};
}
function ctaOk(a){
  var href=a.getAttribute('href')||'',h=hostOf(href);
  if(!CH[h])return 0;
  if(h==='apps.apple.com'&&!/id6757739071|id6742150062/.test(href))return 0;
  if(h==='play.google.com'&&!/com\.backstageai\.merch|com\.backstageai\.backstageai/.test(href))return 0;
  if(/3d-merch-designer\.vercel\.app/.test(href))return 0;
  return 1;
}
function placeOf(a,href){
  var d=a.closest('[data-mrch-placement]');if(d&&d.getAttribute('data-mrch-placement'))return d.getAttribute('data-mrch-placement');
  var h=hostOf(href);
  if(a.closest('[class*="announcement"]'))return /download/.test(href)?'announcement_download':'announcement_design_sell';
  if(a.closest('header'))return 'header_design_cta';
  if(a.closest('[class*="hero"]'))return 'hero_secondary';
  if(a.closest('footer')){
    if(h==='apps.apple.com')return 'footer_app_store';if(h==='play.google.com')return 'footer_play';
    return /\/download/.test(href)?'footer_web':'footer_design_cta';
  }
  if(boot.page_type==='product')return 'pdp_body_sellmerch';
  if(boot.page_type==='collections_index')return 'browse_creators_cta';
  return 'unknown';
}
function addAnon(a){
  var href=a.getAttribute('href')||'',h=hostOf(href);
  if(h!=='sellmerch.ai'&&h!=='www.sellmerch.ai')return;
  try{var u=new URL(href,loc().href);if(!u.searchParams.get('mp_anon')&&st.anon){u.searchParams.set('mp_anon',st.anon);a.setAttribute('href',u.toString());}}catch(e){}
}
function brandAttrsFrom(source){
  var out={},s=source||{},keys=['brand','brand_network','design_slug','dest'],i,k,v;
  for(i=0;i<keys.length;i++){k=keys[i];v=s[k];if(v!=null&&String(v).trim())out[k]=String(v).trim();}
  return out;
}
function brandAttrsFromUrl(search){
  var out={},p,v;
  try{p=new URLSearchParams(search||loc().search||'');}catch(e){return out;}
  v=su(p.get('attributes[brand]')||p.get('brand'));if(v)out.brand=v;
  v=su(p.get('attributes[brand_network]')||p.get('brand_network'));if(v)out.brand_network=v;
  v=su(p.get('attributes[design_slug]')||p.get('design_slug'));if(v)out.design_slug=v;
  v=su(p.get('attributes[dest]')||p.get('dest'));if(v)out.dest=v;
  return out;
}
/* Brand Factory cart attributes are first-party order attribution, not analytics:
   they are written regardless of the Mixpanel consent gate (tracking stays gated). */
var BA_KEYS=['brand','brand_network','design_slug','dest'],BA_SS='mrch_ba_',baSent={};
function brandAttrsFromSS(){
  var out={},i,v;for(i=0;i<BA_KEYS.length;i++){v=su(g(SS,BA_SS+BA_KEYS[i]));if(v)out[BA_KEYS[i]]=v;}return out;
}
function mergeBrandAttrs(){
  var a=brandAttrsFrom((boot.cart&&boot.cart.attributes)||{}),s=brandAttrsFromSS(),b=brandAttrsFromUrl();
  var out={},k;for(k in a)out[k]=a[k];for(k in s)out[k]=s[k];for(k in b)out[k]=b[k];
  for(k in out)p(SS,BA_SS+k,out[k]);
  st.ba=out;return out;
}
function cartUpdUrl(){return (w.theme&&w.theme.routes&&w.theme.routes.cart_update_url)||'/cart/update.js';}
/* Idempotent: only POSTs keys whose value differs from what the cart already has or
   what we last sent; only our four keys are sent, so other cart attributes are untouched. */
function stampBrandCartAttrs(force){
  var attrs=mergeBrandAttrs(),cur=brandAttrsFrom((boot.cart&&boot.cart.attributes)||{}),body={attributes:{}},n=0,k;
  for(k in attrs){if(attrs[k]&&(force||(attrs[k]!==cur[k]&&attrs[k]!==baSent[k]))){body.attributes[k]=attrs[k];n++;}}
  if(!n||!w.fetch)return Promise.resolve();
  var req;
  try{req=w.fetch(cartUpdUrl(),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body),keepalive:true})
    .then(function(r){if(r&&r.ok){for(k in body.attributes)baSent[k]=body.attributes[k];}}).catch(function(){});}catch(e){return Promise.resolve();}
  /* Never hold checkout hostage to a slow cart API. */
  return Promise.race([req,new Promise(function(res){setTimeout(res,2500);})]);
}
function hasBA(){var a=st.ba||mergeBrandAttrs();return !!Object.keys(a).length;}
function cartForm(f){var a=(f&&f.getAttribute&&f.getAttribute('action'))||'';return /(^|\/)cart\/?(\?|$)/.test(a.replace(/^https?:\/\/[^\/]+/,''));}
function onBrandSubmit(ev){
  var f=ev.target;if(!cartForm(f)||!hasBA())return;
  if(f.__mrchBA){f.__mrchBA=0;return;}
  ev.preventDefault();var sub=ev.submitter||null;
  stampBrandCartAttrs(1).then(function(){
    f.__mrchBA=1;
    try{if(f.requestSubmit){f.requestSubmit(sub&&sub.form===f?sub:undefined);return;}}catch(e){}
    if(sub&&sub.name){var h=w.document.createElement('input');h.type='hidden';h.name=sub.name;h.value=sub.value||'';f.appendChild(h);}
    f.__mrchBA=0;f.submit();
  });
}
function onBrandClick(ev){
  var t=ev.target,a=t&&t.closest?t.closest('a,button'):null,href;if(!a||!hasBA())return;
  if(a.__mrchBA){a.__mrchBA=0;return;}
  if(tag(a)==='BUTTON'){
    if(a.getAttribute('name')!=='checkout')return;
    if(a.form&&cartForm(a.form))return; /* the submit hook re-stamps it */
    ev.preventDefault();ev.stopPropagation();
    stampBrandCartAttrs(1).then(function(){a.__mrchBA=1;a.click();});return;
  }
  href=a.getAttribute('href')||'';
  if(!/\/checkout(\b|\/|\?|$)/.test(href))return;
  if(ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.button)return;
  ev.preventDefault();
  stampBrandCartAttrs(1).then(function(){w.location.href=a.href||href;});
}
function brandInit(){
  mergeBrandAttrs();stampBrandCartAttrs();
  var doc=w.document;doc.addEventListener('submit',onBrandSubmit,true);doc.addEventListener('click',onBrandClick,true);
  doc.addEventListener('ajaxProduct:added',function(){stampBrandCartAttrs(1);});
  if(w.theme&&w.theme.pubsub&&w.theme.pubsub.subscribe){
    try{w.theme.pubsub.subscribe(w.theme.pubsub.PUB_SUB_EVENTS.cartUpdate,function(){stampBrandCartAttrs(1);});}catch(e){}
  }
}
function cartPost(force){
  if(st.cs==='denied'||!st.on)return;
  var t=Date.now();if(!force&&t-st.cts<10000&&st.cts)return;st.cts=t;
  var url=(w.theme&&w.theme.routes&&w.theme.routes.cart_update_url)||'/cart/update.js';
  var body={attributes:{_mp_distinct_id:st.anon||'',_mp_session_id:st.sid||'',_mp_entry_source_type:g(SS,K.e)||'unknown',_mp_first_touch_source:g(LS,K.fs)||'',_mp_first_touch_medium:g(LS,K.fm)||'',_mp_first_touch_campaign:g(LS,K.fc)||'',_mp_utm_source:g(SS,K.us)||'',_mp_utm_medium:g(SS,K.um)||'',_mp_utm_campaign:g(SS,K.uc)||'',_mp_utm_content:g(SS,K.un)||'',_mp_utm_term:g(SS,K.ut)||'',_mp_app_id:'mrch_shop',_mp_environment:env()}};
  /* Re-include Brand Factory attrs so a replace-style update cannot wipe them. */
  var ba=st.ba||mergeBrandAttrs(),k;for(k in ba){if(ba[k])body.attributes[k]=ba[k];}
  try{w.fetch(url,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body),keepalive:true});}catch(e){}
}
function onAtc(detail){
  var p=detail&&(detail.product||detail);if(!p)return;
  var vid=String(p.id||p.variant_id||'');if(!vid)return;
  if(Date.now()-(st.atc[vid]||0)<1000)return;st.atc[vid]=Date.now();
  var qty=Number(p.quantity||1),cents=p.final_line_price!=null?Number(p.final_line_price):Number(p.price||0)*qty;
  track('Add To Cart',{product_id:String(p.product_id||(boot.product&&boot.product.product_id)||''),variant_id:vid,quantity:qty,value:Number((cents/100).toFixed(2)),currency:boot.currency||'USD',price:Number(((p.price!=null?Number(p.price):cents/qty)/100).toFixed(2)),store_id:storeId(boot.product,p.vendor)});
  cartPost();
}
function onCheckout(){
  if(g(SS,K.c)===(st.sid||''))return;p(SS,K.c,st.sid||'');cartPost(1);
  var cart=boot.cart||{},stores={},props,ba,k;(cart.lines||[]).forEach(function(l){if(l.store_id)stores[l.store_id]=1;});
  props={item_count:Number(cart.item_count||0),value:Number(((cart.total_price_cents||0)/100).toFixed(2)),currency:cart.currency||boot.currency||'USD',creator_count:Object.keys(stores).length,cart_id_hash:st.ch||undefined};
  ba=st.ba||mergeBrandAttrs();
  for(k in ba){if(ba[k])props[k]=ba[k];}
  track('Checkout Started',props);
}
function tag(n){return n&&(n.tagName||'').toUpperCase();}
function onClick(ev){
  var t=ev.target,a=t;
  if(t&&t.closest){a=t.closest('a')||t.closest('button')||t;}
  if(!a)return;
  if(tag(a)==='BUTTON'&&a.getAttribute&&a.getAttribute('name')==='checkout'){if(okClick(ev))onCheckout();return;}
  if(a.closest&&a.closest('.additional-checkout-buttons')){if(okClick(ev))onCheckout();return;}
  if(tag(a)!=='A')return;
  var href=a.getAttribute('href')||'';
  if((a.classList&&a.classList.contains('social-sharing__link'))||(a.closest&&a.closest('share-drawer')&&a.closest('.share-buttons'))){
    if(!okClick(ev))return;track('Share Initiated',Object.assign({share_channel:shareCh(href)||'web_share'},shareObj()));return;
  }
  if(ctaOk(a)){if(!okClick(ev))return;addAnon(a);track('Creator CTA Clicked',{destination_domain:hostOf(href),placement:placeOf(a,href)});return;}
  if(a.closest&&a.closest('.product-card')&&/\/products\//.test(href)){
    if(!okClick(ev))return;var obj=cardObj(a);if(!obj.object_id)return;
    var x={object_type:obj.object_type,object_id:obj.object_id,placement:obj.placement,position:obj.position};
    if(boot.product&&boot.product.store_id)x.store_id=boot.product.store_id;track('Discovery Card Clicked',x);
  }
}
function onSubmit(ev){
  var f=ev.target;if(!f||!f.getAttribute)return;if((f.getAttribute('action')||'').indexOf('search')<0)return;
  var el=f.querySelector('[name="q"]'),q=el&&el.value?String(el.value).trim():'';if(!q)return;
  var klass=qClass(q),rc=-1,pred=f.closest('predictive-search,[data-predictive-search]');
  if(pred&&pred.getAttribute('results'))rc=Number(pred.getAttribute('results'))||-1;
  if(klass==='redacted'){track('Search Submitted',{result_count:rc,query_class:'redacted'});return;}
  fireSearch(rc,q.length);
}
function bind(){
  var doc=w.document;doc.addEventListener('click',onClick,true);doc.addEventListener('submit',onSubmit,true);
  doc.addEventListener('ajaxProduct:added',function(ev){onAtc(ev.detail);});
  if(w.theme&&w.theme.pubsub&&w.theme.pubsub.subscribe){
    try{w.theme.pubsub.subscribe(w.theme.pubsub.PUB_SUB_EVENTS.cartUpdate,function(d){if(d&&d.source==='product-form')onAtc(d);});}catch(e){}
  }
  spots();
}
function wipe(){
  var i,key,rm=[],ck;
  Object.keys(K).forEach(function(k){d(LS,K[k]);d(SS,K[k]);});
  try{if(LS){for(i=0;i<LS.length;i++){key=LS.key(i);if(key&&(key.indexOf('mp_')===0||key.indexOf('mrch_mp_')===0))rm.push(key);}rm.forEach(function(k){LS.removeItem(k);});}}catch(e){}
  try{(w.document.cookie||'').split(';').forEach(function(c){ck=c.split('=')[0].trim();if(ck.indexOf('mp_')===0||ck.indexOf('mrch_mp_')===0)w.document.cookie=ck+'=; Max-Age=0; path=/';});}catch(e){}
}
function bot(){var n=w.navigator||{};return !!(n.webdriver||/bot|crawl|spider|headless/i.test(n.userAgent||'')||(w.Shopify&&w.Shopify.designMode));}
function intern(){try{if(new URLSearchParams(loc().search||'').get('mrch_internal')==='1')return 1;}catch(e){}return /(?:^|;\s*)mrch_internal=1(?:;|$)/.test(w.document.cookie||'');}
function initMp(){
  if(st.on)return;var m=mix();if(!m||!m.init)return;
  /* init() builds the real instance and swaps window.mixpanel; the reference we
     called it on is still the pre-init stub, so re-read before using the API. */
  var r=m.init(boot.token,{track_pageview:false,persistence:'localStorage',ignore_dnt:false,batch_requests:true,property_blacklist:['$email','$phone','$name'],api_payload_format:'json',autocapture:false,record_sessions_percent:0});
  if(r&&r.track&&r.register)m=r;else if(mix()&&mix().register)m=mix();
  if(!m||!m.register||!m.track)return;
  if(m.stop_session_recording)m.stop_session_recording();
  m.register({environment:env(),app_id:'mrch_shop',event_schema_version:boot.event_schema_version||'1.0'});
  if(intern())m.register({is_internal:true});
  var anon=g(LS,K.a);if(!anon){anon=uuid();p(LS,K.a,anon);}st.anon=anon;if(m.identify)m.identify(anon);
  st.nw=!g(LS,K.f);if(st.nw)p(LS,K.f,new Date().toISOString());
  touch();st.on=1;
  if(boot.cart&&boot.cart.token){var tok=String(boot.cart.token);boot.cart.token=null;sha(tok).then(function(h){st.ch=h;});}
  bind();mergeBrandAttrs();pageView();
}
/* Mixpanel's CDN build (mixpanel-2-latest.min.js) refuses to create window.mixpanel
   unless the vendor stub is already present; without it the library logs
   'mixpanel object not initialized' and no event ever sends. This is Mixpanel's
   published loader snippet with their own script injection removed, because we
   inject the tag ourselves below. */
function stubMp(){
  var b=w.mixpanel||[];
  if(b.__SV)return;
  w.mixpanel=b;b._i=[];
  b.init=function(tok,cfg,name){
    function q(a,d){var x=d.split('.');2==x.length&&(a=a[x[0]],d=x[1]);a[d]=function(){a.push([d].concat(Array.prototype.slice.call(arguments,0)));};}
    var a=b;
    if(typeof name!=='undefined')a=b[name]=[];else name='mixpanel';
    a.people=a.people||[];
    a.toString=function(f){var d='mixpanel';'mixpanel'!==name&&(d+='.'+name);f||(d+=' (stub)');return d;};
    a.people.toString=function(){return a.toString(1)+'.people (stub)';};
    var m='disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove'.split(' ');
    for(var i=0;i<m.length;i++)q(a,m[i]);
    var g='set set_once union unset remove delete'.split(' ');
    a.get_group=function(){
      function h(k){o[k]=function(){var args=arguments;a.push([e,[k].concat(Array.prototype.slice.call(args,0))]);};}
      for(var o={},e=['get_group'].concat(Array.prototype.slice.call(arguments,0)),c=0;c<g.length;c++)h(g[c]);
      return o;
    };
    b._i.push([tok,cfg,name]);
  };
  b.__SV=1.2;
}
var sdkState=0,sdkQueue=[];
function loadSdk(cb){
  if(sdkState===2){cb();return;}
  /* A real Mixpanel already on the page (another app, or the test harness): use it. */
  if(sdkState===0&&mix()&&mix().init){sdkState=2;cb();return;}
  sdkQueue.push(cb);
  if(sdkState===1)return;
  sdkState=1;stubMp();
  var s=w.document.createElement('script');s.src=boot.cdn||'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';s.async=true;
  s.onload=function(){sdkState=2;var q=sdkQueue.splice(0,sdkQueue.length);for(var i=0;i<q.length;i++)q[i]();};
  s.onerror=function(){sdkState=0;sdkQueue.length=0;};
  (w.document.head||w.document.documentElement).appendChild(s);
}
function readConsent(){
  var cp=w.Shopify&&w.Shopify.customerPrivacy,can=1,c='no_interaction';
  if(!cp)return {can:can,c:c};
  try{can=!!cp.userCanBeTracked();}catch(e){}
  try{c=cp.getTrackingConsent()||'no_interaction';}catch(e){}
  return {can:can,c:c};
}
function apply(can,c){
  if(can&&(c==='yes'||c==='no_interaction')){st.cs=c==='yes'?'granted':'auto_granted';loadSdk(initMp);return;}
  if(!can&&c==='no_interaction')return;
  if(!can&&c==='no'){st.cs='denied';wipe();return;}
  if(!can&&c==='yes'){st.cs='granted';loadSdk(initMp);}
}
function privacy(){var r=readConsent();apply(r.can,r.c);}
function start(){
  try{brandInit();}catch(e){}
  if(bot())return;
  w.document.addEventListener('trackingConsentAccepted',function(){st.cs='granted';loadSdk(initMp);});
  w.document.addEventListener('visitorConsentCollected',privacy);
  if(w.Shopify&&w.Shopify.loadFeatures)w.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1',onLoad:privacy}]);
  else if(w.Shopify&&w.Shopify.customerPrivacy)privacy();
  else apply(1,'no_interaction');
}
if(H){
  w.MRCH_ANALYTICS_TEST={classify:classify,parseUtms:parseUtms,common:common,sanitizeUtm:su,queryClass:qClass,start:start,initMixpanel:initMp,applyConsent:apply,state:st,pageView:pageView,fireSearch:fireSearch,onAtc:onAtc,onCheckout:onCheckout,keys:K,ctaOk:ctaOk,stampBrandCartAttrs:stampBrandCartAttrs,mergeBrandAttrs:mergeBrandAttrs,brandInit:brandInit};
}else start();
})(typeof window!=='undefined'?window:this);
